import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {
  COMPONENT_REGISTRY_TOKEN,
  INITIAL_TABS_TOKEN,
  SvgService,
  TabsService,
  TabState,
  ThemeService,
  provideUserListHelp
} from "frontier";
import {ComponentRegistry} from "./home/config/component-registry";
import {CalculusStore} from "./Services/calculus.store";
import {ITab} from "frontier/browserkit/src/lib/components/home-without-gl/tabs/tab.interface";
import {UserRolesHelpComponent} from "./home/views/user-roles-help/user-roles-help.component";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";


const initialTabs: TabState = {
  tabs: [
    {componentName: 'ProcessOverviewComponent', label: 'Prozessübersicht', tabId: 'process-overview'},
  ],
  selectedTabIndex: 0
}

@Component({
  selector: 'kpi4me-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    RouterOutlet,
  ],
  providers: [
    {provide: COMPONENT_REGISTRY_TOKEN, useValue: ComponentRegistry},
    {
      provide: INITIAL_TABS_TOKEN,
      useValue: initialTabs,
    },
    provideUserListHelp({helpComponent: UserRolesHelpComponent}),
    TabsService,
  ]
})
export class AppComponent {
  title = 'calculus';

  svgService = inject(SvgService);  // is actually used, this is falsely detected by Webstorm
  themeService = inject(ThemeService);  // is actually used, this is falsely detected by Webstorm
  tabsService = inject(TabsService);
  calculusStore = inject(CalculusStore);

  constructor() {
    this.calculusStore.helpRoute$.pipe(takeUntilDestroyed()).subscribe(
      (): void => {
        const helpRoute: string = this.calculusStore.helpRoute();
        if (!helpRoute && helpRoute != '') {
          return;
        }
        const tab: ITab = this.tabsService.tabs().find((tab: ITab): boolean => tab.tabId === 'help-view');

        console.log(tab);
        // prevent adding the same tab twice
        if (!tab) {
          this.tabsService.openTab('Handbuch', 'HelpViewComponent', 'help-view');
          return;
        }

        this.tabsService.selectTabById('Handbuch');
      }
    )
  }
}
